import {connect} from "react-redux";
import React, {Component} from 'react'
import {changeTabIndex} from "../../redux/actions/action";

class CloudCourse extends Component {

    constructor (props) {
        super(props)
        this.state = {
            name:'CloudCourse',
            way: 0,
        }
    }

    componentDidMount () {
        let stuId = this.props.userInfo.user.student.stuId
        this.loadCourse();
    }

    render () {

        return ''

    }

    loadCourse = () => {
        window.location.href = 'https://www.zxx.edu.cn/syncClassroom'
    }

}

const mapStateToProps = state => ({
    tabIndex: state.appState.tabIndex,
    userOpenid: state.redUserInfo.userOpenid,
    userInfo: { ...state.redUserInfo },
})

const mapDispatchToProps = dispatch => ({
    changeTabIndex: (tabIndex) => {
        dispatch(changeTabIndex(tabIndex))
    },
})

export default connect(mapStateToProps, mapDispatchToProps,)(CloudCourse)